import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import DateTimePicker from './DateTimePicker';
import YearMonthPicker from './YearMonthPicker';
import Browser from './Browser';


export default class BrowserElement extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, card } = this.props;
        const path = cell.getPath();
        const { fieldtype } = card.getFieldProps(path);
        if (fieldtype == '2') {
            return (
                <DatePicker ecId={`${this && this.props && this.props.ecId || ''}_DatePicker@bgv1o2`} {...this.props} />
            )
        } else if (fieldtype == '19') {
            return (
                <TimePicker ecId={`${this && this.props && this.props.ecId || ''}_TimePicker@eubz6j`} {...this.props} />
            )
        }else if (fieldtype == '290'){
            return (
                <DateTimePicker ecId={`${this && this.props && this.props.ecId || ''}_DateTimePicker@uycxo2`} {...this.props} />
            )
        }else if(fieldtype == '402' || fieldtype == '403'){//年、年月
            return(
                <YearMonthPicker ecId={`${this && this.props && this.props.ecId || ''}_YearMonthPicker@frexqt`} {...this.props}/>
            )
        }else {
            return (
                <Browser ecId={`${this && this.props && this.props.ecId || ''}_Browser@iflpum`} {...this.props} />
            )
        } 
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/index.tsx